import { useTranslation } from "react-i18next";
import useDialog from "../../utils/hooks/useDialog";

// Shared by every dialog on the Users page — create/edit user, delete
// confirmation, department manager, staff import. Lives in its own module so
// the import modal can reuse the exact chrome rather than growing a second,
// slightly-different dialog that drifts.
function ModalShell({ title, subtitle, onClose, children, maxWidth = "max-w-md" }) {
  const { t } = useTranslation();
  // Escape + focus trap + focus restore + body-scroll lock.
  const dialogRef = useDialog(onClose);
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 p-4"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div
        ref={dialogRef}
        role="dialog"
        aria-modal="true"
        tabIndex={-1}
        className={`bg-white rounded-2xl shadow-2xl w-full ${maxWidth} max-h-[88vh] flex flex-col p-6 focus:outline-none`}
      >
        <div className="flex items-start justify-between gap-3 mb-4 shrink-0">
          <div className="min-w-0">
            <h3 className="text-base font-bold text-slate-900">{title}</h3>
            {subtitle && <p className="text-xs text-slate-500 mt-0.5">{subtitle}</p>}
          </div>
          <button
            type="button"
            onClick={onClose}
            className="shrink-0 text-slate-400 hover:text-slate-600 focus-visible:outline-none focus-visible:text-slate-700"
            aria-label={t("common.close")}
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="overflow-y-auto -mr-2 pr-2">{children}</div>
      </div>
    </div>
  );
}

export default ModalShell;
